
export const portfolioBlotterPromptHead = `
    Identify the tickers that changed in the portfolio across snapshots whether being moved into or out of, and explain
    in client-friendly languaging how the portfolios changes benefitted the client. If the portfolio outperformed the benchmark
    and most of the holding options, discuss moves that led to this, if the portfolio underperformed, find areas that
    still highlight the advisor and talk about those such as holdings that still did worse, or consistency and stability,
    that might have resulted in lower returns but smoother path. Make sure to highlight the key stats whether returns % or 
    weight change % for the key details. Use Markdown to format the text.`

